import { auth } from '../firebase';

const API_BASE_URL = 'https://adminportalapi-tirqr4wbva-uc.a.run.app';

/**
 * Make an authenticated API request to the admin portal API
 * @param {string} endpoint - The API endpoint (e.g., '/users/search')
 * @param {object} options - Fetch options (method, body, etc.)
 * @returns {Promise} - The response data
 */
export const authenticatedFetch = async (endpoint, options = {}) => {
  try {
    // Get the current user's ID token
    const currentUser = auth.currentUser;
    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    const token = await currentUser.getIdToken();

    // Prepare headers
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers,
    };

    // Make the request
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

/**
 * Helper functions for common HTTP methods
 */
export const api = {
  get: (endpoint) => authenticatedFetch(endpoint, { method: 'GET' }),
  
  post: (endpoint, data) => authenticatedFetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  patch: (endpoint, data) => authenticatedFetch(endpoint, {
    method: 'PATCH',
    body: JSON.stringify(data),
  }),
  
  put: (endpoint, data) => authenticatedFetch(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),
  
  delete: (endpoint) => authenticatedFetch(endpoint, { method: 'DELETE' }),
};
